import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { DiccionarioMensajes_ES } from '../../Configuracion/Idiomas/DiccionarioMensajes_ES';
import { DiccionarioMensajes_EN } from '../../Configuracion/Idiomas/DiccionarioMensajes_EN';

export const AsignaIdomaEtiquetas = (IndicaIdioma, dispatch) => {

    let etiquetasCambio = DiccionarioEtiquetas.IdiomaDefault.Etiquetas;
    let idiomaCambio = DiccionarioEtiquetas.IdiomaDefault.Idioma;
    let codigoIdiomaCambio = DiccionarioEtiquetas.IdiomaDefault.CodIdiomaDefault;
    try {
        // Se extrae la lista de etiquetas en funcion del idioma que se envia a solicitar
        switch (IndicaIdioma) {
            case "EN":
                codigoIdiomaCambio = DiccionarioEtiquetas.Idiomas.EN.Idioma;
                etiquetasCambio = DiccionarioEtiquetas.Idiomas.EN.Etiquetas;
                idiomaCambio = DiccionarioEtiquetas.Idiomas.EN.Idioma;
                break;
            case "ES":
                codigoIdiomaCambio = DiccionarioEtiquetas.Idiomas.ES.Idioma;
                etiquetasCambio = DiccionarioEtiquetas.Idiomas.ES.Etiquetas;
                idiomaCambio = DiccionarioEtiquetas.Idiomas.ES.Idioma;
                break;
            case "DEFAULT":
                codigoIdiomaCambio = DiccionarioEtiquetas.Idiomas.ES.Idioma;
                etiquetasCambio = DiccionarioEtiquetas.IdiomaDefault.Etiquetas;
                idiomaCambio = DiccionarioEtiquetas.IdiomaDefault.Idioma;
                break;
            default:
                codigoIdiomaCambio = DiccionarioEtiquetas.Idiomas.ES.Idioma;
                etiquetasCambio = DiccionarioEtiquetas.IdiomaDefault.Etiquetas;
                idiomaCambio = DiccionarioEtiquetas.IdiomaDefault.Idioma;
        }
        window.localStorage.setItem("etiqueta_idioma", idiomaCambio);//Se guarda idioma en LocalStorage
    } catch (error) {

    }

    // se hace el dispatch de cambio de idioma en funcion del que se envia par asignar al reduce 
    dispatch({
        type: "ASIGNA_IDIOMA",
        etiquetasIdioma: {
            CodigoIdioma: codigoIdiomaCambio,
            Idioma: idiomaCambio,
            Etiquetas: etiquetasCambio
        }
    });
}

export const obtenerMensajeIdiomaCodigo = (indicaIdioma, codigo) => {
    //const selectedIdioma = window.localStorage.getItem("etiqueta_idioma");
    let respuestaMensaje = '';
    switch (indicaIdioma) {
        case "EN":
            respuestaMensaje = DiccionarioMensajes_EN.find(objMensaje => objMensaje.codigo === codigo);
            break;
        case "ES":
            respuestaMensaje = DiccionarioMensajes_ES.find(objMensaje => objMensaje.codigo === codigo);
            break;
        case "DEFAULT":
            respuestaMensaje = DiccionarioMensajes_ES.find(objMensaje => objMensaje.codigo === codigo);
            break;
        default:
            respuestaMensaje = DiccionarioMensajes_ES.find(objMensaje => objMensaje.codigo === codigo);
    }

    if (respuestaMensaje === undefined || respuestaMensaje === null || respuestaMensaje === '') {
        respuestaMensaje = {
            'codigo': '',
            'mensaje': codigo
        };
    } else {
        try {
            const mensajeRespuesta = respuestaMensaje.mensaje;
            const termina = mensajeRespuesta.slice(-1);

            const caracteres = '.,?!';

            if (caracteres.includes(termina) === false) {
                respuestaMensaje = {
                    'codigo': codigo,
                    'mensaje': mensajeRespuesta + '.'
                };
            }
        } catch (ee) { }
    }

    return respuestaMensaje;
}

export const enlistaArrayCodigosMensajesIdiomas = (dataErrores) => {
    const listErroresArrays = Object.keys(dataErrores);
    const dataArraysErrores = dataErrores;

    let arrayErrores = [];
    let clave = '';

    for (var i = 0; i < listErroresArrays.length; i++) {
        clave = listErroresArrays[i];
        let tem = dataArraysErrores[clave];

        for (var x = 0; x < tem.length; x++) {

            arrayErrores = [...arrayErrores, tem[x]];
        }
    }
    return arrayErrores;
}

export default AsignaIdomaEtiquetas;
